<template>
  <div class="vault-screen not-found-screen">
    <div class="card">
      <div class="card-body">
        <h2 class="not-found-title">404</h2>
        <p class="not-found-message">That page is not in the vault.</p>
      </div>
    </div>
  </div>
</template>

<style src="./pagenotfound.css" />
<script src="./pagenotfound.js"></script>